import { Suspense } from "react";

const Noop = () => null;

/**
 * A Higher-Order Component (HOC) that wraps a React component in a Suspense boundary.
 * 
 * This is crucial for components that use React Query with `suspense: true` or 
 * lazy-loaded components. It automatically renders the provided Placeholder 
 * (loading skeleton) while the wrapped Component is fetching data or loading.
 * 
 * @param {React.ComponentType} Component - The main component to render once ready.
 * @param {React.ComponentType} [Placeholder] - The fallback component (e.g., a Shimmer skeleton) to show while suspended.
 * @returns {React.FC} A new component wrapped in a Suspense boundary.
 */
const withPlaceholder = (Component, Placeholder) => (props) => {
  return (
    <Suspense fallback={Placeholder ? <Placeholder /> : <Noop />}>
      <Component {...props} />
    </Suspense>
  );
};

export default withPlaceholder;
